/**
 * Link that blocks navigation when there are unsaved changes on the Interaction page.
 * Dispatches a custom event to trigger the unsaved-changes modal.
 */

import { Link, useLocation } from 'react-router-dom';
import { useUnsavedChanges } from '../../contexts/UnsavedChangesContext.jsx';

const INTERACTION_PATTERN = /^\/relais\/beneficiaires\/[^/]+\/interaction$/;

export default function BlockableLink({ to, onClick, children, ...rest }) {
  const location = useLocation();
  const { hasUnsavedChanges } = useUnsavedChanges();

  const isOnInteractionPage = INTERACTION_PATTERN.test(location.pathname);
  const targetPath = typeof to === 'string' ? to : (to?.pathname ?? '');
  const isNavigatingAway = targetPath && targetPath !== location.pathname;

  const handleClick = (e) => {
    if (hasUnsavedChanges && isOnInteractionPage && isNavigatingAway) {
      e.preventDefault();
      window.dispatchEvent(new CustomEvent('unsaved-navigate-attempt', { detail: { path: targetPath } }));
    }
    onClick?.(e);
  };

  return (
    <Link to={to} onClick={handleClick} {...rest}>
      {children}
    </Link>
  );
}
